import { useServiceUnavailableError } from './useServiceUnavailableError';

export function useETMUnavailableError() {
   return useServiceUnavailableError({
      errorMessages: {
         default: 'Unable to retrieve external training modules, please try again.',
      },
      serviceName: 'External Training Modules',
   });
}
